/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetDogmaDynamicItemsTypeIdItemIdNotFound
 */
export interface GetDogmaDynamicItemsTypeIdItemIdNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetDogmaDynamicItemsTypeIdItemIdNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetDogmaDynamicItemsTypeIdItemIdNotFound interface.
 */
export function instanceOfGetDogmaDynamicItemsTypeIdItemIdNotFound(value: object): value is GetDogmaDynamicItemsTypeIdItemIdNotFound {
    return true;
}

export function GetDogmaDynamicItemsTypeIdItemIdNotFoundFromJSON(json: any): GetDogmaDynamicItemsTypeIdItemIdNotFound {
    return GetDogmaDynamicItemsTypeIdItemIdNotFoundFromJSONTyped(json, false);
}

export function GetDogmaDynamicItemsTypeIdItemIdNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDogmaDynamicItemsTypeIdItemIdNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetDogmaDynamicItemsTypeIdItemIdNotFoundToJSON(json: any): GetDogmaDynamicItemsTypeIdItemIdNotFound {
    return GetDogmaDynamicItemsTypeIdItemIdNotFoundToJSONTyped(json, false);
}

export function GetDogmaDynamicItemsTypeIdItemIdNotFoundToJSONTyped(value?: GetDogmaDynamicItemsTypeIdItemIdNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

